const StudioRoute = {
  path: "/studio",
  component: () => import("@/components/metrics/containers/Studio"),
  children: [
    {
      path: "public/:magic_link",
      component: () => import("@/components/metrics/containers/MetricStudio"),
    },
    {
      path: ":mode",
      component: () => import("@/components/metrics/containers/MetricStudio"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "",
      redirect: "/studio/edit",
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default StudioRoute;
